import React, { useState } from 'react'
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { formatFirebaseTimestamp } from '../../utils/datetime';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import SyncIcon from '@mui/icons-material/Sync';
import HubIcon from '@mui/icons-material/Hub';
import { useModal } from "../../contexts/ModalContext.js";
import { updateRequest } from '../../api/ContactAPI';


export default function Requests({ contactRequests, setcontactRequests, toggleConfirmDialog }) {
    const { openModal } = useModal();
    const [hoveredRequestId, setHoveredRequestId] = useState(null);

    const [sortOrder, setSortOrder] = useState('desc');
    const sortedContactRequestData = [...contactRequests].sort((a, b) => {
        const dateA = new Date(a.createdAt.toDate());
        const dateB = new Date(b.createdAt.toDate());
        return sortOrder === 'asc' ? dateA - dateB : dateB - dateA;
    });

    const toggleSortOrder = () => {
        setSortOrder(prev => (prev === 'asc' ? 'desc' : 'asc'));
    };

    const handleCopy = async (value) => {
        await navigator.clipboard.writeText(value);
        openModal("alert", {
            alertProps: { type: 2, message: "Copied" },
        });
    };

    async function statusClicked(requestId, status) {
        const res = await updateRequest(requestId, status)
        if (res.success) {
            setcontactRequests(contactRequests.map((request) => {
                if (request.id === requestId) {
                    return { ...request, status: status };
                }
                return request;
            }))
        }
    }

    return (
        <table className="request-table" style={{paddingBottom:'180px'}}>
            <thead>
                <tr>
                    <th style={{ width: '44px', textAlign: 'center' }}>
                        <SyncIcon sx={{ fontSize: '16px', color: '#6c757d' }} />
                    </th>
                    <th>
                        <div className="sort-control" onClick={() => toggleSortOrder()}>
                            <div className="sort-arrows">
                                <ArrowDropUpIcon sx={{ color: sortOrder === "asc" ? 'var(--color-primary)' : '#adb5bd', fontSize: '18px', transform: 'translateY(4px)' }} />
                                <ArrowDropDownIcon sx={{ color: sortOrder === "desc" ? 'var(--color-primary)' : '#adb5bd', fontSize: '18px', transform: 'translateY(-4px)' }} />
                            </div>
                            Date
                        </div>
                    </th>
                    <th>First Name</th>
                    <th>Last Name</th>
                    <th>Email</th>
                    <th>Request</th>
                    <th>Status & Actions</th>
                </tr>
            </thead>
            <tbody>
                {contactRequests.length === 0 ? (
                    <tr>
                        <td colSpan="7" className="empty-state">No requests yet</td>
                    </tr>
                ) : sortedContactRequestData.map((request, index) => (
                    <tr key={index} className="request-row">
                        <td style={{ textAlign: 'center' }}>
                            {request?.forNewroConnect === true && (
                                <HubIcon sx={{ fontSize: '16px', color: '#8b5cf6' }} />
                            )}
                        </td>
                        <td style={{ fontWeight: 500, color: '#1a1a2e' }}>{formatFirebaseTimestamp(request?.createdAt)}</td>
                        <td>{request?.fName}</td>
                        <td>{request?.lName}</td>
                        <td>
                            <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                {request?.email}
                                <ContentCopyIcon 
                                    onClick={() => handleCopy(request.email)} 
                                    sx={{ fontSize: '14px', cursor: 'pointer', color: '#adb5bd', '&:hover': { color: 'var(--color-primary)' } }} 
                                />
                            </span>
                        </td>
                        <td 
                            className="request-content-cell"
                            onMouseEnter={() => setHoveredRequestId(request.id)}
                            onMouseLeave={() => setHoveredRequestId(null)}
                        >
                            <span className="request-preview">
                                {request?.request}
                            </span>
                            {hoveredRequestId === request.id && request?.request && (
                                <div className="request-tooltip">
                                    {request.request}
                                </div>
                            )}
                        </td>
                        <td>
                            <div className="table-actions" style={{ justifyContent: 'flex-start', gap: '12px' }}>
                                {request?.status === 'pending' ? (
                                    <div onDoubleClick={() => statusClicked(request.id, 'handled')} className="request-status-icon">
                                        Pending
                                    </div>
                                ) : (
                                    <div onDoubleClick={() => statusClicked(request.id, 'pending')} className="request-status-icon handled">
                                        Handled
                                    </div>
                                )}
                                <DeleteForeverIcon 
                                    className="delete-icon"
                                    onClick={() => toggleConfirmDialog(true, 'DELETE request. Are you sure?', 'deleteRequest', request.id)} 
                                    sx={{ color: '#adb5bd', cursor: 'pointer', fontSize: '18px', '&:hover': { color: '#dc3545' } }} 
                                />
                            </div>
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    )
}